import React from 'react';
import PropTypes from 'prop-types';
import { ErrorMessage } from 'formik';

import CheckboxMultiSelect from 'components/CheckboxMultiSelect';

const Checkboxes = props => {
  const {
    name,
    required,
    labelText,
    values,
    placeholder = 'Group',
    isValid,
    options,
    hasGroups,
    onChange,
    onBlur,
  } = props;

  return (
    <div className="form__group form__group--compact">
      <CheckboxMultiSelect
        name={name}
        label={labelText}
        labelStyles={{
          fontWeight: 'bold',
        }}
        required={required}
        isValid={isValid}
        items={options}
        selectedItems={values}
        placeholder={placeholder}
        groups={hasGroups}
        onChange={onChange}
        onBlur={onBlur}
      />
      <ErrorMessage
        name={name}
        render={message => <div className="form__error">{message}</div>}
      />
    </div>
  );
};

const CheckboxesItem = PropTypes.shape({
  label: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
});

Checkboxes.propTypes = {
  name: PropTypes.string,
  required: PropTypes.bool,
  labelText: PropTypes.string,
  values: PropTypes.arrayOf(CheckboxesItem),
  placeholder: PropTypes.string,
  isValid: PropTypes.bool,
  options: PropTypes.arrayOf(CheckboxesItem),
  hasGroups: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
};

export default Checkboxes;
